var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/key/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M6.81575 8.38861C6.71647 8.21699 6.53324 8.1113 6.33498 8.1113H3.34215L2.2312 7.00038L1.83846 7.39312L2.2312 7.00038L3.34144 5.88964H6.33498C6.53324 5.88964 6.71647 5.78395 6.81575 5.61233C7.29676 4.78081 8.19444 4.22339 9.22165 4.22339C10.7554 4.22339 11.9987 5.46673 11.9987 7.00047C11.9987 8.53421 10.7554 9.77755 9.22165 9.77755C8.19444 9.77755 7.29676 9.22013 6.81575 8.38861Z",
    stroke: "#6F767E",
    strokeWidth: 1.11083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M9.77709 7.00146C9.77709 7.30821 9.52842 7.55688 9.22167 7.55688C8.91493 7.55688 8.66626 7.30821 8.66626 7.00146C8.66626 6.69471 8.91493 6.44604 9.22167 6.44604C9.52842 6.44604 9.77709 6.69471 9.77709 7.00146Z",
    stroke: "#6F767E",
    strokeWidth: 1.11083
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.3fc58c08c2370e95150a55c029b3a86a.svg";
export { ForwardRef as ReactComponent };